<template>
    <div class="center-div">
        <div class="fixedHeader">
        </div>
        <table class="triptable">
            <transition-group name="list-active" tag="tbody">
                <trip-row :trip="trip" v-for="trip in filteredTrips" :key="trip.id"></trip-row>
            </transition-group>
            <thead>
                <tr class="sticky-header2">
                    <th colspan="8">
                        <filter-trips @status="statusFilter = $event" @date="dateFilter = $event"></filter-trips>
                    </th>
                </tr>

                <trip-header @from="fromFilter = $event" @to="toFilter = $event" @driver="driverFilter = $event" @stock_number="stockFilter= $event"></trip-header>
            </thead>
        </table>
    </div>
</template>

<script>
    import _ from 'lodash'
    import moment from 'moment'
    import TripRow from './TripRow.vue'
    import FilterTrips from './FilterTrips.vue'
    import TripHeader from './TripHeader.vue'

    export default {
      data () {
        return {
          fromFilter: 'all',
          toFilter: 'all',
          driverFilter: 'all',
          statusFilter: 'active',
          dateFilter: 'all',
          stockFilter:'',
        }
      },
      components: {
          'trip-row': TripRow,
          'filter-trips': FilterTrips,
          'trip-header': TripHeader
      },
      methods: {
        filterTrips (trips) {
          trips = trips.filter(x => [x.from, 'all'].includes(this.fromFilter))
          trips = trips.filter(x => [x.to, 'all'].includes(this.toFilter))
          trips = trips.filter(x => x.stock_num.indexOf(this.stockFilter.toUpperCase())>=0)
          trips = trips.filter(x => {
            if (this.driverFilter === 'all') {
              return true
            } else if (this.driverFilter === 'has_driver') {
              return x.drivers.length > 0
            } else if (this.driverFilter === 'needs_driver') {
              return x.drivers === null || x.drivers.length === 0
            } else {
              console.log('bad value for driverFilter =', this.driverFilter)
            }
          })
          trips = trips.filter(x => {
            if (this.dateFilter === 'today') {
              return moment().startOf('day').valueOf() < moment(x.created_at).valueOf() ||
                    moment().startOf('day').valueOf() < moment(x.assigned_time).valueOf() ||
                    moment().startOf('day').valueOf() < moment(x.delivered).valueOf()
            } else if (this.dateFilter === 'week') {
              return moment().startOf('week').valueOf() < moment(x.created_at).valueOf() ||
                    moment().startOf('week').valueOf() < moment(x.assigned_time).valueOf() ||
                    moment().startOf('week').valueOf() < moment(x.delivered).valueOf()
            }
            return true
          })
          let activeTrips = trips.filter(t => t.active)
          let inactiveTrips = trips.filter(t => !t.active)
          activeTrips = _.orderBy(activeTrips, [
            t => -t.waiter,
            t => (new Date(t.appt_time | '01/01/2500')).valueOf(),
            t => -(new Date(t.created_at)).valueOf()
          ])
          inactiveTrips = _.orderBy(inactiveTrips, [
            t => -(new Date(t.updated_at)).valueOf()
          ])
          if (this.statusFilter === 'active') {
            trips = activeTrips
          } else if (this.statusFilter === 'inactive') {
            trips = inactiveTrips
          } else if (this.statusFilter === 'all') {
            trips = activeTrips.concat(inactiveTrips)
          } 
          return trips
        }
      },
      computed: {
          trips () {
              return this.$privateReactiveStore.getTrips()
          },
          filteredTrips () {
              return this.filterTrips(this.trips)
          },
      }
    }
</script>

<style scoped lang="less">
    .TripCreator {
      outline: 1px black solid;
    }
    .center-div {
      margin: auto;
      overflow-y: scroll;
      height: 100%;
    }
    .fixedHeader {
      position: absolute;
      top: 0;
      background-color: white;
      left: 0;
      right: 16px;
      z-index: 1;
      tr {
        border-bottom: 1px solid white;
      }
    }
    @media (max-width: 1270px) {
      tbody {
        tr {
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
    
    .triptable {
      width: 100%;
      border-collapse: separate;
      border-spacing: 1px;
      background-color: black;
      tr:nth-child(odd) {
        background: white;
      }
      tr:nth-child(even) {
        background: rgb(242, 242, 242);
      }
    }
    
    // Hackery so header isn't covered by animations during up/down transitions
    thead th {
      position: relative;
    }
    
    .list-active-enter-active, .list-active-leave-active {
      transition: all 1s;
    }
    .list-active-enter {
      opacity: 0;
    }
    .list-active-move {
      transition-delay: 1s;
    }
    .list-active-leave-to {
      opacity: 0;
      position: absolute;
    }
    .list-active-move {
      transition: all 1s;
    }
    .list-active-enter-active {
      position: relative;
    }
    .list-active-leave-active {
      position: absolute;
      transform: skewX(0deg);
    }
</style>